import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { CommonService } from '@core/services/common-service/common.service';
import { EmployeeService } from '@core/services/employees/employee.service';
import { GlobalConstants } from '@environments/global-Variables';
import { Subject, filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'baker-ripley';
  flag: boolean = false;
  loginDisplay = false;
  isIframe = false;
  // @HostListener('window:resize', ['$event'])
  private readonly _destroying$ = new Subject<void>();
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private service: EmployeeService,
    private commonService: CommonService
  ) {

  }

  ngOnInit(): void {
    this.onWindowSizeExpandingMain();
    // this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    this.setLoginDisplay();
    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: any) => status === InteractionStatus.None || status == ""),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })

    if (localStorage.getItem(GlobalConstants?.USER_ROLE_KEY)) {
      let userRoles: any = localStorage.getItem(GlobalConstants?.USER_ROLE_KEY)
      userRoles = JSON.parse(window.atob(userRoles));
      if (userRoles?.includes(GlobalConstants.ROLE_HR)) {
        // this.commonService.setRoleHRExists(true);
        this.commonService.setRoleHRExists(false);
      } else {
        this.commonService.setRoleHRExists(false);
      }
    }
  }

  // closing menu based on screen size
  onWindowSizeExpandingMain() {
    if (window.innerWidth >= 768 && window.innerWidth <= 1023) {
      this.flag = true;
    }
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }
  mainContainerToggle() {
    this.flag = !this.flag
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (activeAccount) {
      this.commonService.getCommonOptionData();
      this.getTokenValidation();
      this.isIframe = true;
    } else {
      if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
        let accounts = this.authService.instance.getAllAccounts();
        let role: string[];
        role = accounts[0].idTokenClaims?.roles!;
        if (role.includes(GlobalConstants.ROLE_HR)) {
          this.commonService.setRoleHRExists(false);
        } else {
          this.commonService.setRoleHRExists(false);
        }
        localStorage.setItem(GlobalConstants.USER_ROLE_KEY, window.btoa(JSON.stringify(role)));
        let TokenData: any;
        TokenData = accounts[0].idToken;
        let accountDetails: any = {};
        accountDetails.name = accounts[0].name;
        accountDetails.username = accounts[0].username;
        localStorage.setItem(GlobalConstants.CURRENT_USER_DET_KEY, window.btoa(JSON.stringify(accountDetails)));
        if (accounts[0]) {
          this.isIframe = true;
        }
        this.authService.instance.setActiveAccount(accounts[0]);
        this.commonService.getCommonOptionData();
      } else {
        this.loginRedirect();
      }
    }


  }

  async getTokenValidation() {
    await this.service.getTokenValidation().subscribe((res: any) => {
      if (res) {
        localStorage.setItem('Validation', 'true');
        // this.router.navigate(["/pending-approval"]); //Bug - 424 (this line giving the issue when page is refreshed application is landing to pending approval)
      } else {
        localStorage.setItem('Validation', 'false');
        this.router.navigate(["/"]);
      }
    })
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    } else {
      this.authService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    }
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
    }
  }
}
